<template>
	<transition name='dialogShow'>
		<div id='crossAnalysisDialog' v-show='isDialogShow' v-loading='dialogLoading'>
			<el-scrollbar class="default-scrollbar">
				<div style='padding-right: 20px'>
			<div>
				<el-button type='text' size='small'  @click='handleClickSQ'>收起</el-button>
			</div>
			<el-row class='BBName'>
				<el-col :span='15'>
					<span>报表名称：</span>
					<el-input size='mini' placeholder='请输入报表名称' style='width:180px;' v-model='form.name'></el-input>
				</el-col>
				<el-col :span='9' style='text-align: right'>
					<span style='margin-right: 20px;cursor: pointer;' @click="handleDeleteAll">取消</span>
					<el-button size='mini' class='minButton' @click='handleSaveList'>保存为报表</el-button>
				</el-col>

			</el-row>
			<div class='container_JXFX clearfix'> 
				<div class='item_operation fl'>
					<!-- 字段 -->
					<div>
						<span class='title_JXFX'><img src="/static/icon/ZD_s.png" alt="">字段</span>
						<div class='item_operation_s'>
							<el-scrollbar class="default-scrollbar">
								 <draggable :value='ZDlist'
								 			:group='getSetList("1")'
								 			 @choose='handleZDMoves'
								 			@unchoose="handleZDEnds"
								 >

									<div class='item_operation_list ZD_super' v-for='(i,index) in ZDlist' :key='i.id' :customType = 'i.customTypes'>
										<img :src="'/static/icon/'+(i.customTypes==='1'?'text_s.png':i.customTypes==='2'?'date_s.png':i.customTypes==='3'?'number_s.png':'select_s.png')"

										 alt="" style='display: inline-block;margin-bottom: 2px;margin-right: 5px;'>
										{{i.name}}
									</div>
								</draggable>
							</el-scrollbar>
						</div>
					</div>
					<!-- 行 -->
					<div>
						<span class='title_JXFX'><img src="/static/icon/rows.png" alt="">行</span>
						<div class='item_operation_s'>
							<el-scrollbar class="default-scrollbar">
								 <draggable v-model='form.rows' :group='getSetList("2")'
								 			class='item_operation_s_D'
								 			 @choose='handleZDMove($event,"h")'
									 		@unchoose="handleZDEnd"
									 		@change='handleAddItem($event,"h")'
									 		draggable=".my-handle"

								 >
								 	<transition-group name="list" tag="p">
					                     <div v-for = '(i,index) in form.rows' :key = 'i.id' class='item_operation_list clearfix'
					                     	  :class="returnClassName(i,'h')"
					                     	  :style="i.customType==='666'?dragFileStyle:''"
					                     	  :customType = 'i.customTypes'
					                     	  :item = 'i'
					                     >
					                     		{{i.name}}
					                     		<div class='fr'>
					                     			<el-select v-model="i.value"  size='mini' v-if='i.customType==="2"' placeholder=""
					                     					  class='list_select'
					                     					  :class="returnClassNames(i,'h')"
					                     					  @change='handleAddItem($event,"s")'
					                     			>
													    <el-option
													      v-for="item in dateList"
													      :key="item.value"
													      :label="item.label"
													      :value="item.value">
													    </el-option>
												  </el-select>
					                     		</div>

					                     </div> 

					                </transition-group>
								 </draggable>
							</el-scrollbar>
							<div class='model_sss' v-show='rowsViewShow'>
								{{disableText_h}}
							</div>
						</div>
					</div>
				</div>
				<div class='item_operation fr'>
					<!-- 列 -->
					<span class='title_JXFX'><img src="/static/icon/cols.png" alt="">列</span>
					<div class='item_operation_s'>
						<el-scrollbar class="default-scrollbar">
							 <draggable v-model='form.columns'
							 			 :group='getSetList("2")'
							 			 class='item_operation_s_D'
							 			 @choose='handleZDMove($event,"l")'
								 		@unchoose="handleZDEnd"
								 		@change='handleAddItem($event,"l")'
								 		draggable=".my-handle"
							 >
							 	<transition-group name="list" tag="p">
				                     <div v-for = '(i,index) in form.columns' :key = 'i.id' class='item_operation_list clearfix'
				                     	:class="returnClassName(i,'l')"
				                     	:style="i.customType==='666'?dragFileStyle:''"
				                     	:customType = 'i.customTypes'
				                     	:item = 'i'
				                     >
				                     	{{i.name}}
				                     	<div class='fr'>
			                     			<el-select v-model="i.value"  size='mini' v-if='i.customType==="2"' placeholder=""
			                     					  class='list_select'
			                     					   :class="returnClassNames(i,'l')"
			                     					   @change='handleAddItem($event,"s")'
			                     			>
											    <el-option
											      v-for="item in dateList"
											      :key="item.value"
											      :label="item.label"
											      :value="item.value">
											    </el-option>
										  </el-select>
			                     		</div>
				                     </div>

				                </transition-group>
							 </draggable>
						</el-scrollbar>
						<div class='model_sss' v-show='columnsViewShow'>
							{{disableText_l}}
						</div>
					</div>
					<!-- 值 -->
					<span class='title_JXFX'><img src="/static/icon/value_s.png" alt="">交叉分析值</span>
					<div class='item_operation_s'>
						<el-scrollbar class="default-scrollbar">
							 <draggable v-model='form.values'
							 			  :group='getSetList("2")'
							 			 class='item_operation_s_D'
							 			  @choose='handleZDMove($event,"z")'
								 		@unchoose="handleZDEnd"
								 		@change='handleAddItem($event,"z")'
								 		draggable=".my-handle"
							 >
				                     <div v-for = '(i,index) in form.values' :key = 'index' class='item_operation_list clearfix'
				                     	:class="returnClassName(i,'z')"
				                     	:style="i.customType==='666'?dragFileStyle:''"
				                     	:customType = 'i.customTypes'
				                     	:item = 'i'
				                     	>
				                     		{{i.name}}
				                     		<div class='fr' v-if='i.customType!=="666"'>
												  <el-select v-model="i.value"  size='mini' v-if='i.customType==="3"' placeholder=""
												  			 class='list_select'
												  			  :class="returnClassNames(i,'z')"
												  			  @change='handleAddItem($event,"s")'
												  			 >
												    <el-option
												      v-for="item in numberList"
												      :key="item.value"
												      :label="item.label"
												      :value="item.value">
												    </el-option>
												  </el-select>
												  <span v-else>计数</span>
				                     		</div>
				                     </div>
							 </draggable>
						</el-scrollbar>
						<div class='model_sss' v-show='valuesViewShow'>
							{{disableText_z}}
						</div>
					</div>
				</div>
			</div>


			</div>
		</el-scrollbar>
		<!-- 删除区域 -->
			<div class='deleteView' v-show='deleteViewShow'>
				<draggable v-model='deleteList'
				 			  :group='getSetList("3")'
				 			 class='item_operation_s_Ds'
				 			 @add='handleAddItem($event,"d")'
							 >
							 <i class='el-icon-delete'></i>
				</draggable>

			</div>
		</div>
	</transition>
</template>
<script>
	import draggable from 'vuedraggable'
	export default {
		props: {
			drawer:Boolean,
			formData:Object,
			newTabId:String,
			newTabName:String
		},
		components: {
			draggable
		},
		data() {
			return {
				disableText_h:'当前区域不可拖动',   // 禁用拖入提示
				disableText_l:'当前区域不可拖动',   // 禁用拖入提示
				disableText_z:'当前区域不可拖动',   // 禁用拖入提示
				bacaID:"",  // 上一个ID
				columnsViewShow:false, // 列是否可拖拽
				rowsViewShow:false,   // 行是否可拖拽
				valuesViewShow:false,   // 值是否可拖拽
				valuesList:[],  // 当前的值列表深拷贝
				isHaveItem_s:null,   // 帅选条件
				nowMoveItemName:"",    // 当前移动项目的名称
				nowMoveItemType:"",    // 当前移动项目的类型
				dragFileStyle:{
					textAlign:'center',
					background:'#fff',
					color:'#9B9B9B',
					border:'1px solid rgba(233,233,233,1)'
				},
				deleteList:[],   // 删除数据集合
				deleteViewShow:false,   // 删除区域显示
				form:{
					name:"",         // 报表名称
					id:"",
					rows:[],
          columns:[],
          values:[]
				},
				dateList:[],     // 日期下拉
				numberList:[],      // 数值下拉
				ZDlist:[],  // 所有字段
				dialogLoading: false, // loading
				dragFile:{
					customType: "666",
					customTypes: "666",
					id: "1941104",
					name: "拖入字段",
					unit: "",
					isAnimationShow:false,
				}

			}
		},
		created() {
			this.getAllDataList();
			this.getAllList_ZD();
		},
		computed: {
			isDialogShow:{
				get() {
					return this.drawer;
				},
				set(val){
					this.$emit('update:drawer',val);
				}

			}
		},
		methods: {
		// 取消
		handleDeleteAll() {
			this.isDialogShow = false;
			this.form = {
				name:"",
				id:"",
				rows:[],
       			columns:[],
       			values:[]
			}
			// 告诉父组件点击取消按钮
			this.$emit('deleteItem',true);
		},
		//返回下拉框样式
		returnClassNames(i,t) {
			if(t==="l" && this.columnsViewShow) {
				return 'columnsViewShowStyles'
			}
			if(t==="h" && this.rowsViewShow) {
				return 'columnsViewShowStyles'
			}
			if(t==="z" && this.valuesViewShow) {
				return 'columnsViewShowStyles'
			}
			return "";
		},
		// 返回class名字
		returnClassName(i,t) {
			if(t==="l" && this.columnsViewShow) {
				return 'columnsViewShowStyle'
			}
			if(t==="h" && this.rowsViewShow) {
				return 'columnsViewShowStyle'
			}
			if(t==="z" && this.valuesViewShow) {
				return 'columnsViewShowStyle'
			}
			if(i.customType!=="666") {
				return 'my-handle';
			}else {
				return "";
			}
		},
		//  拖入验证
		handleAddItem(e,type) {
			if(type==="z") {
				if(this.nowMoveItemType==="3"&&e.added&&this.form.values.length>2) {
						this.form.values.splice(e.added.newIndex,1,{
							customType: this.nowMoveItemType,
							customTypes: this.nowMoveItemType,
							id: Math.floor(Math.random()*1000000)+"",
							name: this.nowMoveItemName,
							unit: "",
							customColumnId:e.added.element.customColumnId,
							value:"np.sum",
							isAnimationShow:false,
						})

				}
				// 删除拖入字段重新push
				this.deleteZD_drag(this.form.values,"v");

				// over===================================================
			}else if(type==='h') {
				// 删除拖入字段重新push
				this.deleteZD_drag(this.form.rows,"h");
			}else if(type==="l") {
				// 删除拖入字段重新push
				this.deleteZD_drag(this.form.columns,"l");
			}
      let formData = this.$lodash.cloneDeep(this.form);
      // 过滤拖入字段
      formData = this.filterSurplusData(formData);
			if(this.form.columns.length>1||this.form.rows.length>1||this.form.values.length>1) {
				// 检测到数据合格开始实时请求
				this.$emit("fastShow",{
					columns:formData.columns,
					rows:formData.rows,
					values:formData.values,
				});
			}

		},
    // 删除拖入字段
    filterSurplusData(data) {
      let arrName = ["columns","rows","values"];
      arrName.forEach(name=>{
        if(data[name].length) {
          data[name].forEach((i,index)=>{
            if(i.customType === "666") {
              data[name].splice(index,1);
            }
          })
        }
      })
      return data;
    },
		// 删除拖入字段重新push
		deleteZD_drag(arr,type) {
			let data = arr.find(i=>{return i.id==="1941104"});
			if(data) {
				arr.forEach((i,index)=>{
					if(i.id==='1941104') {
						arr.splice(index,1);
						if(arr.length<3 && type!=="v") {
							arr.push(this.dragFile);
						}
						if(type==="v") {
							arr.push(this.dragFile);
						}
					}
				})
			}else {
				arr.push(this.dragFile);
			}

		},
		// 拖动工具开始================================================
			// 检测阻止拖入的数据
			// preventRowsData(arr,data) {
			// 	try {
			// 		let isTrue=false;
			// 		if(!arr || !data) {
			// 			return isTrue;
			// 		}
			// 		if(arr.length) {
			// 			let a = arr.find(i=>{return i.name===data})
			// 			// 添加动画
			// 			//动画结束
			// 			if(a) {
			// 				arr.forEach (i=>{
			// 					if(a.name === i.name) {
			// 						i.isAnimationShow = true;
			// 					}
			// 				})

			// 				isTrue=true;

			// 			}else {
			// 				isTrue=false;
			// 			}
			// 		}else {
			// 			isTrue=false;

			// 		}
			// 		setTimeout(()=>{
			// 			arr.forEach (i=>{
			// 				i.isAnimationShow = false;
			// 			})
			// 		},300)
			// 		return isTrue;


			// 	}catch(e) {
			// 		console.log(e)
			// 	}

			// },

		// 拖动工具结束=====================================================
			// 保存表报
			handleSaveList() {
				let form = JSON.parse(JSON.stringify(this.form));
				if(form.rows[form.rows.length-1].customType==="666") {
					form.rows.splice(-1,1);
				}
				if(form.columns[form.columns.length-1].customType==="666") {
					form.columns.splice(-1,1);
				}
				form.values.splice(-1,1);
				this.dialogLoading = true;
				this.$http.post('analysis/save',form).then(res=>{
					this.dialogLoading = false;
					if(res&&res.data.code==1) {
						this.$message.success(res.data.msg);
						this.$emit('successSave',this.newTabId);
						this.isDialogShow = false;
						this.form = {
							name:"",
							id:"",
							rows:[],
							columns:[],
							values:[]
						}
					}
				})
			},
			// 获取拖拽选项配置项
			getSetList(type) {
				let group = {
					name: "menu", //多项拖动统一名字
					animation: 150,  // ms, 动画速度运动项目排序时，' 0 ' -没有动画。
					put: true,   // 是否允许拖入
					sort:true,  // 是否允许排序
					dragClass: "sortable-drag",  // 拖动class
					chosenClass:"sortable-chosen",  //  选中class
					ghostClass: "",  // 设置拖动元素的class的占位符的类名。
				}
				if(type==="1") {
					group = Object.assign(group,{
						put: false,
						sort:false,
					})
				}else if(type==="2") {
					group = Object.assign(group,{
						ghostClass: "sortable-ghost",
					})
				}else if(type==="3") {
					group = Object.assign(group,{
						ghostClass: "sortable-ghosts",
						sort:false,
					})
				}
				return group;
			},
			// 拖动最大验证方法
			isMaxList(arr,type) {
				if(!arr.length) {return false};
				let arr_last = arr[arr.length-1].customType;
			   if((arr_last==="666"&&arr.length===4) || (arr_last!=="666"&&arr.length===3)) {
			   		return true;
			   }else{
			   		return false;
			   }

			},
			// 字段拖动结束
			handleZDEnd(e) {
				this.deleteViewShow = false;
				this.columnsViewShow = false;
				this.rowsViewShow = false;
				this.valuesViewShow= false;
				// 重置
				this.disableText_h = "当前区域不可拖动";
				this.disableText_l = "当前区域不可拖动";
				this.disableText_z = "当前区域不可拖动";
			},
			// 字段拖动结束s
			handleZDEnds(e) {
				this.columnsViewShow = false;
				this.rowsViewShow = false;
				this.valuesViewShow= false;
				// 重置
				this.disableText_h = "当前区域不可拖动";
				this.disableText_l = "当前区域不可拖动";
				this.disableText_z = "当前区域不可拖动";
			},
			// 字段移动
			handleZDMove(e,type) {
				this.nowMoveItemType = e.item.attributes.customtype.value;
				this.nowMoveItemName = e.item.innerText?(e.item.innerText.split(/[\n,]/g))[0]:"";
				this.deleteViewShow = true;

				// 最大限制
				   // 列的最大限制

				if(type === "h") {
				   let isTrue = this.isMaxList(this.form.columns,type);
				   if(isTrue) {
				   		this.columnsViewShow = true;
						this.disableText_l =  "最大限制3列";
						return;
				   }
				 }

				// }
				 // 行的最大限制
				 if(type === "l") {
				   let isTrue = this.isMaxList(this.form.rows,type);
				   if(isTrue) {
				   		this.rowsViewShow = true;
						this.disableText_h =  "最大限制3行";
						return;
				   }
				 }

				// ===============================================
				// 拖动验证
				if(type==="z") {

					// 检测到重复不能拖入
					if(this.form.columns.length) {
						this.form.columns.forEach(i=>{
							if(i.name===this.nowMoveItemName) {
								this.columnsViewShow = true;
								//检测到另一个有不能拖入
								this.rowsViewShow = true;
								this.disableText_l = this.nowMoveItemName+"重复";
								this.disableText_h = this.nowMoveItemName+"列已存在";
							}
						})
					}
					if(this.form.rows.length) {
						this.form.rows.forEach(i=>{
							if(i.name===this.nowMoveItemName) {
								this.rowsViewShow = true;
								//检测到另一个有不能拖入
								this.columnsViewShow = true;
								this.disableText_h = this.nowMoveItemName+"重复";
								this.disableText_l = this.nowMoveItemName+"行已存在";
							}
						})
					}


					// 检测最大长度
					let iscolumnsMax = this.isMaxList(this.form.columns,type);
					if(iscolumnsMax) {
						this.columnsViewShow = true;
						this.disableText_l =  "最大限制3列";
					}
					let isrowsMax = this.isMaxList(this.form.rows,type);
					if(isrowsMax) {
						this.rowsViewShow = true;
						this.disableText_h =  "最大限制3行";
					}

				}else if(type==="l" || type==="h") {
					//检测值非数字类型不能重复
					if(this.nowMoveItemType!=="3") {
						if(this.form.values.length) {
							this.form.values.forEach(i=>{
								if(i.name===this.nowMoveItemName) {
									this.valuesViewShow = true;
									this.disableText_z = this.nowMoveItemName+"重复";
								}
							})
						}
					}
				}

			},
			// 字段移动s
			handleZDMoves(e) {
				this.nowMoveItemType = e.item.attributes.customtype.value.trim();
				this.nowMoveItemName = e.item.innerText.trim();
				let haveC,haveR;
				//从字段拖入验证

								// 最大限制
				   // 列的最大限制
					let iscolumnsMax = this.isMaxList(this.form.columns);
					if(iscolumnsMax) {
						this.columnsViewShow = true;
						this.disableText_l =  "最大限制3列";
					}
					// 行最大值检测
					let isrowsMax = this.isMaxList(this.form.rows);
					if(isrowsMax) {
						this.rowsViewShow = true;
						this.disableText_h =  "最大限制3行";
					}
				// 检测到重复不能拖入
					if(this.form.columns.length) {
						this.form.columns.forEach(i=>{
							if(i.name===this.nowMoveItemName) {
								this.columnsViewShow = true;
								//检测到另一个有不能拖入
								this.rowsViewShow = true;
								this.disableText_l = this.nowMoveItemName+"重复";
								this.disableText_h = this.nowMoveItemName+"列已存在";
							}
						})
					}
					if(this.form.rows.length) {
						this.form.rows.forEach(i=>{
							if(i.name===this.nowMoveItemName) {
								this.rowsViewShow = true;
								//检测到另一个有不能拖入
								this.columnsViewShow = true;
								this.disableText_h = this.nowMoveItemName+"重复";
								this.disableText_l = this.nowMoveItemName+"行已存在";
							}
						})
					}

				// 检测值重复
				    //如果不是数字类型则不能重复
				if(this.nowMoveItemType!=="3") {
					if(this.form.values.length) {
						this.form.values.forEach(i=>{
							if(i.name===this.nowMoveItemName) {
								this.valuesViewShow = true;
								this.disableText_z = this.nowMoveItemName+"重复";
							}
						})
					}
				}

			},
			// 点击收起
			handleClickSQ() {

				this.isDialogShow = false;
			},
			// 字段请求
			getAllDataList() {
				this.dialogLoading = true;
				let params = JSON.parse(JSON.stringify(this.formData));
				params.displayZero = params.displayZero?1:0;
				this.$http.post('analysis/findCustomColumn',params).then(res=>{
					this.dialogLoading = false;
		              if(res&&res.data.code==1) {
		                	this.ZDlist = res.data.data.map(i=>{
		                		i.value="";
		                		i.isAnimationShow=false;
		                		if(i.customTypes==="3"){
		                			i.value='np.sum';
		                		}
		                		return i;
		                	});
		              }
		          })
			},
			// 请求字典表
			getAllList_ZD() {
				// 日期字典表
				this.$http.post('sys/dict/list' , {type:"cross_analysis_date"}).then(res=>{
					if(res&&res.data.code==1){
						this.dateList = res.data.data;
						this.dateList.push({
							description: "交叉分析",
							id: "666666",
							label: "全部",
							sort: 1,
							type: "cross_analysis_date",
							value: ""
						})
					}
				})

				// 数值字典表
				this.$http.post('sys/dict/list' , {type:"cross_analysis_value"}).then(res=>{
					if(res&&res.data.code==1){
						this.numberList = res.data.data;

					}
				})

			},
			//  加入尾部标识
			addDragTip() {
				if(!this.form.rows.find(i=>{return i.name===this.dragFile.name})){
					this.form.rows.push(this.dragFile);
				}
				if(!this.form.columns.find(i=>{return i.name===this.dragFile.name})){
					this.form.columns.push(this.dragFile);
				}
				if(!this.form.values.find(i=>{return i.name===this.dragFile.name})){
					this.form.values.push(this.dragFile);
				}
			}

		},
		watch: {
			isDialogShow(val) {
				if(val) {
					if(this.newTabId) {
						if(this.newTabId==="193520" || !this.isDialogShow){
							return
						};
						// if(this.newTabId===this.bacaID&&this.form.rows.length&&this.form.columns.length&&this.form.values.length) {
						// 	return;
						// }
						this.bacaID = this.newTabId;
							this.form.name=this.newTabName;
							this.form.id=this.newTabId;
							// 获取报表类容
							this.$http.post('analysis/findAnalysisContent' , {id:this.newTabId}).then(res=>{
								if(res&&res.data.code==1){
									this.form.rows = res.data.data.row;
									this.form.columns = res.data.data.column;
									this.form.values = res.data.data.value;
									this.addDragTip();
								}
							})

					}else {
						this.form = {
							name:"",
							id:"",
							rows:[],
			       			columns:[],
			       			values:[]
						}
						this.addDragTip();
					}
				}
			},
			newTabId(val) {
				if(!this.isDialogShow) {return}
				if(val&&this.isDialogShow&&val!=="193520") {
					if(val===this.bacaID) {
						return;
					}
					this.bacaID = val;
					this.form.name=this.newTabName;
					this.form.id=this.newTabId;
					// 获取报表类容
					this.$http.post('analysis/findAnalysisContent' , {id:this.newTabId}).then(res=>{
						if(res&&res.data.code==1){
							this.form.rows = res.data.data.row;
							this.form.columns = res.data.data.column;
							this.form.values = res.data.data.value;
							this.addDragTip();
						}
					})
				}else {
					this.form = {
							name:"",
							id:"",
							rows:[],
			       			columns:[],
			       			values:[]
						}
						this.addDragTip();
				}
			},
	  		'form.rows':{
	  			handler(val,oldVal) {
	  				if(oldVal.length<val.length) {
	  					let res=  new Map();
	  					let data = val.filter((a) => !res.has(a.name) && res.set(a.name, 1))
	  					this.form.rows = data;
	  					// if(val.length!==data.length) {
	  					// 	this.form.values = this.valuesList;
	  					// }
	  					// this.form.rows = Array.from(new Set(val));
	  				}
	  			},
	  			deep:true
	  		},
	  		'form.columns':{
	  			handler(val,oldVal) {
	  				if(oldVal.length<val.length) {
	  					let res=  new Map();
	  					let data = val.filter((a) => !res.has(a.name) && res.set(a.name, 1))
	  					this.form.columns = data;
	  					// this.form.columns = Array.from(new Set(val));
	  					// if(val.length!==data.length) {
	  					// 	this.form.values = this.valuesList;
	  					// }
	  				}
	  			},
	  			deep:true
	  		},
	  		// 'form.values':{
	  		// 	handler(val,oldVal) {
	  		// 		if(oldVal.length<val.length) {
	  		// 			this.form.values = Array.from(new Set(val));
	  		// 			this.isHaveItem_s = oldVal.find(i=>{return i.name===this.nowMoveItemName})
	  		// 		}
	  		// 	},
	  		// 	deep:true
	  		// },
		}
	}
</script>
<style lang='less'>
    .dialogShow-enter-active,.dialogShow-leave-active {
    	transition: all .2s linear;
    }
    .dialogShow-enter,.dialogShow-leave-to {
    	opacity: 0;
        transform: translateX(532px);
    }
	#crossAnalysisDialog {
		width: 490px;
		height: 9rem;
		background-color: #fff;
		border:1px solid #eee;
		position: fixed;
		right:0;
		bottom: 0;
		border-radius: 5px;
		z-index: 2001;
		padding: .20rem 0rem .2rem .3rem;
		box-sizing: border-box;
		overflow-y:hidden;
		.my-handle {

		}
		.default-scrollbar {
				width: 100%;
				height: 100%;
				.el-scrollbar__view {
					width: calc(100%);
					height: 100%;
				}
			}
			.el-scrollbar__wrap,.default-scrollbar__wrap {
			  overflow-x: hidden;
			}
		/*拖动区域*/
		.item_operation_s_D {
			width: 100%;
			height: 100%;
			p{
				width: 100%;
				height: 100%;
			}
		}
		.item_operation_s_Ds {
			width: 100%;
			height: 100%;
			overflow: hidden;
			p{
				width: 100%;
				height: 100%;
			}
		}
		/*抖动特效*/
		@keyframes shake {
			0%{
				transform: translateX(0px);
			}
			50%{
				transform: translateX(-5px);
			}
			100%{
				transform: translateX(5px);
			}
		}

		/*删除区域*/
		.deleteView {
			width: 100%;
			height: 100px;
			position: absolute;
			top: 0;
			left: 0px;
			line-height: 100px;
			text-align:center;
			background:rgba(0,0,0,.4);
			i {
				font-size: 25px;
				color: red;
			}
		}

		/*拖动效果开始*/
			.sortable-drag {
				background-color: #269D7B;
			}
			.sortable-chosen {
				background-color: #269D7B;
			}
			.sortable-ghost {
				display: block;
				margin: 20px 20px 20px 0px;
				padding: 6px 8px;
				background-color: #E9E9E9;
				color: #4A4A4A;
				border-radius: 2px;
				opacity: .5;
			}
			.sortable-ghosts {
				display: none;
			}

		/*拖动效果结束===========================================================*/
		.BBName {
			margin-top: .10rem;
		}
		 /*** 元素定位改变时动画 ***/
		  .list-move {
		    transition: transform .0s;
		  }
		.container_JXFX {
			margin-top: .30rem;
			.default-scrollbar {
				width: 100%;
				height: 100%;
				.el-scrollbar__view {
					width: calc(100%);
					height: 100%;
				}
			}
			.el-scrollbar__wrap,.default-scrollbar__wrap {
			  overflow-x: hidden;
			}
			.title_JXFX{
				color: #333333;
				font-weight: 600;
				img {
					display: inline-block;
					margin-right: 10px;
					margin-bottom: 2px;
				}
			}
			.item_operation {
				.item_operation_s {
					margin-top:.20rem;
					margin-bottom:.20rem;
					width:200px;
					height:2.9rem;
					border:1px solid rgba(233,233,233,1);
					box-sizing: border-box;
					padding-left: 20px;
					overflow-y: hidden;
					position: relative;
					overflow-x:hidden;
					.model_sss {
						width:199px;
						height:2.9rem;
						position: absolute;
						top: 0;
						left: 0;
						text-align:center;
						line-height: 2.9rem;
						color: red;
						font-weight: 600;
						background: rgba(0,0,0,.1);
						z-index: 999;
					}
				}
				/*添加动画*/
				.columnsViewShowStyle {
					background-color: #fff !important;
					color: #999 !important;
					border:1px solid #eee !important;
				}
				.item_operation_list {
						margin: 19px 20px 19px 0px;
						padding: 6px 8px;
						background-color: #268AFF;
						color: #fff;
						border-radius: 2px;
						border:1px solid #fff;
						cursor: move;
						&:hover {
							/*box-shadow: 1px 1px 1px 1px #268AFF;*/
							border:1px solid #268AFF;
						};
						.columnsViewShowStyles {
							.el-input__inner {
								background-color: #fff !important;
								color: #999 !important;
							}
						}
						.list_select{
							width: 80px;
							.el-input__inner {
								border:none;
								outline: none;
								box-shadow: none;
								background-color: #268AFF;
								height: 18px;
								line-height: 18px;
								color: #fff;
							}
							.el-input__icon {
								line-height: 18px;
							}
						}
					}
				.ZD_super {
					background-color: #fff !important;
					color: #4A4A4A !important;
					border:1px solid #fff;
					&:hover{
							border:1px solid rgba(0,145,255,1);
						};

				}
				.item_operation_value {
					width:220px;
					margin-top:20px;
					height:268px;
					border:1px solid rgba(233,233,233,1);
					box-sizing: border-box;
					padding-left: 20px;
					overflow: hidden;
				}

			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/dialog/crossAnalysisDialog.vue